import { stringDateToKvartal, stringDateToPPP } from "../../../../../util/date";
import { AccordionCard } from "../../../../accordion/Accordion";
import { DisplayItem } from "../../../../formcontrols/DisplayItem";
import DocumentIcon from "../../../../icons/DocumentIcon";
import FirmaGennemfoerteTilsyn from "./FirmaGennemfoerteTilsyn";
import FirmaKlientKontoErklaering from "./FirmaKlientErklaering";
import DocumentModal from "../../../../Modal/modals/DocumentModal";
import { FirmaDto } from "../../../../../interfaces/schema";
import { defaultIfNullish } from "../../../../../util/stringUtil";
import { useQuery } from "@apollo/client";
import { GET_FIRMA_TILSYN_BY_ID_QUERY } from "../../../../../api/firma/queries";
import Spinner from "../../../../spinner/Spinner";
import { useState } from "react";
import { transformQueryDataPerioder } from "../../../../../util/apollo";

export default function Tilsyn({ firma }: { firma: FirmaDto }) {
  const { id } = firma;
  const [data, setData] = useState<
    | {
        firma: FirmaDto;
      }
    | undefined
  >(undefined);
  const { loading, error, refetch } = useQuery<{ firma: FirmaDto }>(
    GET_FIRMA_TILSYN_BY_ID_QUERY(),
    {
      variables: { id },
      notifyOnNetworkStatusChange: true,
      onCompleted: (d) => {
        const transformed = transformQueryDataPerioder(d);
        setData(transformed);
      },
    },
  );
  if (loading) return <Spinner />;
  if (error) return <div>noget gik galt 😔</div>;
  if (!data) return null;
  // eslint-disable-next-line no-unsafe-optional-chaining
  const { firmaTilsyn, firmaKlienterklaering } = data?.firma;

  const latestErklaering = firmaKlienterklaering
    ? [...firmaKlienterklaering].sort((a, b) => {
        return b.erklAar - a.erklAar;
      })[0]
    : undefined;

  const latestTilsyn = firmaTilsyn
    ? [...firmaTilsyn].sort((a, b) => {
        return (b.gennemfoerselDato ?? "") > (a.gennemfoerselDato ?? "")
          ? 1
          : -1;
      })[0]
    : undefined;

  const formattedLastTilsyn = () => {
    if (!latestTilsyn) return "-";
    const { gennemfoerselDato, firmaTilsynstypeNavigation } = latestTilsyn;
    let resp = "";
    if (gennemfoerselDato) {
      resp += stringDateToKvartal(gennemfoerselDato);
    }
    return `${resp} - ${firmaTilsynstypeNavigation?.navn ?? ""}`;
  };

  return (
    <div className="container">
      {/* <h2>Oversigt</h2> */}
      <div className="row gy-3">
        <div className="col-12 col-xl-6">
          <div className="c-card flex-grow-1">
            <div className="row align-items-center mb-4">
              <h3 className="col">Klientkontoerklæring</h3>
              <div className="col-auto">
                <DocumentModal
                  disabled={!latestErklaering}
                  getDocument={
                    latestErklaering
                      ? `firma/${firma.id}/klienterklaeringer/${latestErklaering.id}/dokument`
                      : ""
                  }
                  downloadLink={
                    latestErklaering
                      ? `firma/${firma.id}/klienterklaeringer/${latestErklaering.id}/download`
                      : ""
                  }
                  title={
                    <>
                      <DocumentIcon height={20} />
                      Seneste klientkontoerklæring
                    </>
                  }
                  buttonContents={[
                    <DocumentIcon key={1} />,
                    <span key={2}>Vis erklæring</span>,
                  ]}
                  contentProps={{
                    className: "c-document c-document--klienterklaering",
                  }}
                />
              </div>
            </div>
            <div className="c-item-list col">
              <div>
                <DisplayItem
                  label="Erklæringsår"
                  text={latestErklaering?.erklAar}
                />
              </div>
              <div>
                <DisplayItem
                  label="Status"
                  text={
                    latestErklaering?.klienterklaeringStatusNavigation?.navn
                  }
                />
              </div>
              <div>
                <DisplayItem
                  label="Modtaget dato"
                  text={defaultIfNullish(
                    latestErklaering?.erklModtaget
                      ? stringDateToPPP(latestErklaering?.erklModtaget)
                      : "",
                  )}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-xl-6 d-flex align-content-stretch">
          <div className="c-card flex-grow-1">
            <h3 className="mt-2 mb-4">Tilsyn</h3>
            <div className="c-item-list">
              <div>
                <DisplayItem
                  label="Seneste tilsyn"
                  text={formattedLastTilsyn()}
                />
              </div>
              <div>
                <DisplayItem label="Sagsnr. F2" text={latestTilsyn?.sagsNr} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <h2>Flere detaljer</h2> */}
      <AccordionCard
        title="Klientkontoerklæring"
        value="klientkontoerklaering"
        isEmpty={!firmaKlienterklaering || firmaKlienterklaering.length === 0}
        localstorageKey="firma-id-stamoplysninger-accordion-value"
      >
        <FirmaKlientKontoErklaering
          firma={firma}
          firmaKlienterklaering={firmaKlienterklaering}
          invalidateData={refetch}
        />
      </AccordionCard>
      <AccordionCard
        title="Gennemførte tilsyn"
        value="gennemfoerte-tilsyn"
        isEmpty={!firmaTilsyn || firmaTilsyn.length === 0}
        localstorageKey="firma-id-stamoplysninger-accordion-value"
      >
        <FirmaGennemfoerteTilsyn
          firma={firma}
          firmaTilsyn={firmaTilsyn}
          invalidateData={refetch}
        />
      </AccordionCard>
    </div>
  );
}
